/** 네이버 로그인 노출 여부 (네이버 검수 통과 후 NEXT_PUBLIC_NAVER_LOGIN_ENABLED=true 로 활성화) */
export function isNaverLoginEnabled(): boolean {
  return process.env.NEXT_PUBLIC_NAVER_LOGIN_ENABLED === "true";
}
